import mergeReducers from './mergeReducers'

export { mergeReducers }
